import {NativeService} from './native.service';
import {IPlatformService} from './IPlatformService';
import {BrowserService} from './browser.service';
import {Injectable} from '@angular/core';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Injectable({
  providedIn: 'root'
})
export class PlatformService implements IPlatformService {
  private platformService: IPlatformService;

  constructor(private nativeService: NativeService,
              private browserService: BrowserService,
              private loggerService: LoggerService) {
    if (nativeService.isElectronApp) {
      this.platformService = nativeService;
    } else {
      this.platformService = browserService;
    }
  }

  get BrowserName(): string {
    return this.platformService.BrowserName;
  }

  closeApp(): void {
    this.platformService.closeApp();
  }

  get isAndroid(): boolean {
    return this.platformService.isAndroid;
  }

  get isArm(): boolean {
    return this.platformService.isArm;
  }

  get isBrowser(): boolean {
    return this.platformService.isBrowser;
  }

  get isElectronApp(): boolean {
    return this.nativeService.isElectronApp;
  }

  get isIOS(): boolean {
    return this.platformService.isIOS;
  }

  get isLinux(): boolean {
    return this.platformService.isLinux;
  }

  get isMac(): boolean {
    return this.platformService.isMac;
  }

  get isWindows(): boolean {
    return this.platformService.isWindows;
  }

  get isX64(): boolean {
    return this.platformService.isX64;
  }

  get isX86(): boolean {
    return this.platformService.isX86;
  }

  get isHeadless() {
    return this.platformService.isHeadless;
  }

  get isMainWindow() {
    return this.platformService.isMainWindow;
  }

  maximizeApp(): void {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.PlatformService, 'Maximizing app');
    this.platformService.maximizeApp();
  }

  minimizeApp(): void {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.PlatformService, 'Minimizing app');
    this.platformService.minimizeApp();
  }

  openHeadlessWindow(url: string): void {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.PlatformService, `Opening headless window with url: ${url}`);
    this.platformService.openHeadlessWindow(url);
  }

  saveObjectToJsonFile(object: object) {
    this.platformService.saveObjectToJsonFile(object);
  }

  reloadApp(): void {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.PlatformService, 'Reloading app');
    this.platformService.reloadApp();
  }

  openNewWindow(link: string) {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.PlatformService, `Opening new window with url: ${link}`);
    this.platformService.openNewWindow(link);
  }

  openInBrowser(link: string) {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.PlatformService, `Opening in browser with url: ${link}`);
    this.platformService.openInBrowser(link);
  }

  closeCurrentWindow() {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.PlatformService, 'Closing current window');
    this.platformService.closeCurrentWindow();
  }

  requestApplicationExit() {
    this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.PlatformService, 'Requesting application exit');
    this.platformService.requestApplicationExit();
  }
}
